// weightSync.js
function syncWeightInputs(weightTextId, weightRangeId) {
  const weightTextInput = document.getElementById(weightTextId);
  const weightRangeInput = document.getElementById(weightRangeId);

  // Update text input when range slider changes
  weightRangeInput.addEventListener('input', (event) => {
    weightTextInput.value = event.target.value;
  });

  // Update range slider when text input changes
  weightTextInput.addEventListener('change', (event) => {
    // Ensure the text input value is within range slider's min and max
    const min = parseFloat(weightRangeInput.min);
    const max = parseFloat(weightRangeInput.max);
    let value = parseFloat(event.target.value);

    // Empty / non-numeric → fall back to the minimum (no 0kg allowed)
    if (isNaN(value) || value < min) value = min;
    if (value > max) value = max;

    // Force the clamped value back into the manual entry field too
    weightTextInput.value = value;
    weightRangeInput.value = value;
    updateRangeBackground();
  });

  // Update the background gradient of the range slider
  function updateRangeBackground() {
    const value = ((weightRangeInput.value - weightRangeInput.min) / (weightRangeInput.max - weightRangeInput.min)) * 100;
    weightRangeInput.style.background = `linear-gradient(to right, #BFE7AD 0%, #BFE7AD ${value}%, #f3f3f3 ${value}%, #f3f3f3 100%)`;
  }

  // Add background update listeners
  weightRangeInput.addEventListener('input', updateRangeBackground);
  weightTextInput.addEventListener('input', updateRangeBackground);

  updateRangeBackground(); // Initialize on load
}


export default syncWeightInputs